import { useMemberId } from '@trello/authentication';
import { useFeatureGate } from '@trello/feature-gate-client';

import { useBoardMembers } from '../useBoardMembers';
import { useBoardAccessRequestsQuery } from './BoardAccessRequestsQuery.generated';

export const useBoardAccessRequests = ({ boardId }: { boardId: string }) => {
  const { value: isUserLimitsImproveInviteLinkEnabled } = useFeatureGate(
    'trello_user_limit_improved_invite_links',
  );
  const { isAdmin } = useBoardMembers(boardId);
  const memberId = useMemberId();
  const isMemberAdmin = isAdmin(memberId);

  const { data: accessRequestsData, loading } = useBoardAccessRequestsQuery({
    variables: { boardId },
    waitOn: ['None'],
    skip: !isMemberAdmin || !isUserLimitsImproveInviteLinkEnabled,
  });

  return {
    isMemberAdmin,
    loading,
    accessRequests: accessRequestsData?.board?.accessRequests,
  };
};
